/** type of a promo code */
export var BPromoCodeType;
(function (BPromoCodeType) {
    BPromoCodeType["Absolute"] = "ABSOLUTE";
    BPromoCodeType["Percent"] = "PERCENT";
})(BPromoCodeType || (BPromoCodeType = {}));
/** The payments behaviour status. */
export var BPaymentBehaviourEnum;
(function (BPaymentBehaviourEnum) {
    BPaymentBehaviourEnum["Checkout"] = "CHECKOUT";
    BPaymentBehaviourEnum["Free"] = "FREE";
    BPaymentBehaviourEnum["TakeBankImprint"] = "TAKE_BANK_IMPRINT";
})(BPaymentBehaviourEnum || (BPaymentBehaviourEnum = {}));
